export const compressImage = (base64Str, startQuality = 0.9) => {
  return new Promise((resolve) => {
    const img = new Image();
    img.src = base64Str;

    img.onload = () => {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      const MAX_WIDTH = 1000;
      let width = img.width;
      let height = img.height;

      if (width > MAX_WIDTH) {
        height *= MAX_WIDTH / width;
        width = MAX_WIDTH;
      }

      canvas.width = width;
      canvas.height = height;

      ctx.drawImage(img, 0, 0, width, height);

      let quality = startQuality;
      let compressedBase64;

      // Loop until size is between 500KB and 1MB
      const MIN_KB = 500;
      const MAX_KB = 1000;

      while (true) {
        compressedBase64 = canvas.toDataURL("image/jpeg", quality);

        // Calculate size
        const sizeInKB = (compressedBase64.length * (3 / 4)) / 1024;

        // 🟢 If size is correct → stop
        if (sizeInKB >= MIN_KB && sizeInKB <= MAX_KB) {
          break;
        }

        // 🔻 If too small (<500KB) → increase quality
        if (sizeInKB < MIN_KB && quality < 0.95) {
          quality += 0.05;
        }

        // 🔻 If too large (>1MB) → reduce quality
        else if (sizeInKB > MAX_KB && quality > 0.1) {
          quality -= 0.05;
        }

        // Safety break
        else {
          break;
        }
      }

      resolve(compressedBase64);
    };
  });
};
